{
  "name": "cth-video",
  "version": "4.0.0",
  "private": true,
  "type": "module",
  "description": "CTH Video: the mChapters-style clip player at videos.coachtonyhockey.com (player/ is the player, web/ the app around it), on the videos in ~/CTH/videos (served by its own Cloudflare Worker, worker/)",
  "scripts": {
    "check": "node scripts/check.mjs",
    "build:web": "node build-web.mjs",
    "test": "node --check player/player.js && node --check web/app.js && node --check web/obsidian-shim.js && node --check server/local-server.mjs",
    "test:web": "node scripts/check.mjs",
    "ship": "node scripts/ship.mjs"
  },
  "devDependencies": {
    "esbuild": "^0.24.2",
    "lucide": "^1.47.0",
    "mediabunny": "^1.59.0",
    "yaml": "^2.9.1"
  }
}
